if (!customElements.get('neya-ingredient-drawers')) {
  customElements.define(
    'neya-ingredient-drawers',
    class NeyaIngredientDrawers extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-neya-drawer-open]').forEach((button) => {
          button.addEventListener('click', () => {
            const dialog = document.getElementById(button.dataset.neyaDrawerOpen);
            if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
          });
        });

        this.querySelectorAll('[data-neya-drawer]').forEach((dialog) => {
          dialog.querySelector('[data-neya-drawer-close]')?.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
        });
      }
    }
  );
}
